<div class="flight-card-content-container">
  <div class="flight-details spaced-row">
      <div class="flight-id">
          <h4>{{flightDetails?.confirmationID}}</h4>
      </div>
      <div class="status-badge">
        <div *ngIf="flightDetails?.flightStatus?.className" class="status-badge">
          <span class="badge badge-pill {{flightDetails?.flightStatus?.className}}">{{flightDetails?.flightStatus?.description}}</span>
      </div>
      </div>
  </div>
  <div class="timings spaced-row">
      <div class="depart-timings">{{flightDetails?.departureDateTime !== null ? (flightDetails?.departureDateTime |date:'shortTime') : "--"}}</div>
      <div class="arrival-timings">{{flightDetails?.arrivalDateTime!==null ? (flightDetails?.arrivalDateTime |date:'shortTime') : "--"}}</div>
  </div>
  <div class="travel-details">
      <div class="depart-airport">{{flightDetails?.departureAirport?.iataCode}}</div>
      <div class="dashed-line"></div>
      <div class="travel-time">
          {{flightDetails?.travelTime}}
      </div>
      <div class="dashed-line"></div>
      <div class="arrival-airport">{{flightDetails?.arrivalAirport?.iataCode}}</div>
  </div>
  <div class="airport-details spaced-row">
      <div class="depart-details">
          <div class="location">
              <span class="city">{{flightDetails?.departureAirport?.iataCityCode?.name}}</span>
              <span *ngIf="flightDetails?.departureAirport?.iataCityCode?.name && flightDetails?.departureAirport?.iataCityCode?.stateCode?.name">, </span>
              <span class="country">{{flightDetails?.departureAirport?.iataCityCode?.stateCode?.name}}</span>
          </div>
          <div class="date">{{flightDetails?.departureDateTime !== null ? (flightDetails?.departureDateTime |date:'EEE, MMM d, y') : "--"}}</div>
          <div class="terminal">
              <span class="terminal-num">{{flightDetails?.departureTerminal}}</span>
              <span *ngIf="flightDetails?.departureTerminal && flightDetails?.departureGate">, </span>
              <span class="gate-num">Gate {{flightDetails?.departureGate}}</span>
          </div>
      </div>
      <div class="arrival-details">
          <div class="location">
              <span class="city">{{flightDetails?.arrivalAirport?.iataCityCode?.name}}</span>
              <span *ngIf="flightDetails?.arrivalAirport?.iataCityCode?.name && flightDetails?.arrivalAirport?.iataCityCode?.stateCode?.name">, </span>
              <span class="country">{{flightDetails?.arrivalAirport?.iataCityCode?.stateCode?.name}}</span>
          </div>
          <div class="date">{{flightDetails?.arrivalDateTime !==null ? (flightDetails?.arrivalDateTime |date:'EEE, MMM d, y') : "--"}}</div>
          <div class="terminal">
              <span class="terminal-num">{{flightDetails?.arrivalTerminal}}</span>
              <span *ngIf="flightDetails?.arrivalTerminal && flightDetails?.arrivalGate">, </span>
              <span class="gate-num">Gate {{flightDetails?.arrivalGate}}</span>
          </div>
      </div>

  </div>
  <div class="boarding-details">
      <div class="seperator"></div>
      <div class="spaced-row">
          <div class="flight">
              <div class="label">{{pageConstants.flight}}</div>
              <div class="value">{{flightDetails?.carrierCode}} {{flightDetails?.flightNumber}}</div>
          </div>
          <div class="boarding-time">
              <div class="label">{{pageConstants.boardingBegins}}</div>
              <div class="value">{{flightDetails?.boardDateTime!==null ? (flightDetails?.boardDateTime |date:'shortTime') : "--"}}</div>
          </div>
      </div>
      <div class="spaced-row">
          <div class="seat">
              <div class="label">{{pageConstants.seat}}</div>
              <div class="value">{{flightDetails?.seatNumber}}</div>
          </div>
          <div *ngIf="showBaggageStatus; then bagBlock else gateBlock">
          </div>
          <ng-template #gateBlock>
            <div class="gate">
              <div class="label">{{pageConstants.gate}}</div>
              <div class="value">{{flightDetails?.departureGate}}</div>
            </div>
          </ng-template>
          <ng-template #bagBlock>
            <div class="bag-status">
              <div class="label">{{pageConstants.bagCarousel}}</div>
              <div class="value">{{flightDetails?.baggageCarouselId}}</div>
            </div>
          </ng-template>
      </div>
      <div class="more-info" *ngIf="flightDetails?.activeFlightSegment && !hideMoreInformation" (click)="onMoreInformation()">
          <button class="more-info-text link-color unstyle-button" role="link">{{pageConstants.moreInformation}}</button>
          <div class="more-info-icon" [class.expanded]="isExpanded">
              <i aria-hidden="true" class="material-icons">{{pageConstants.expandMore}}</i>
          </div>
      </div>
  </div>
</div>
